import { Controller } from '@hotwired/stimulus';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default class ScrollTriggerController extends Controller {
    initialize() {
        if (!gsap.core.globals().ScrollTrigger) {
            gsap.registerPlugin(ScrollTrigger);
        }
    }
}
